import styled from 'styled-components'

const StyledHashtagFolderList = styled.div`
  overflow-y: auto;
`

export default StyledHashtagFolderList
